export const areaChartData = [
    {
        name: "January",
        users: 4000,
        posts: 2400,
        incidents: 2400,
        communities: 1300
    },
    {
        name: "February",
        users: 3000,
        posts: 1398,
        incidents: 2210,
        communities: 1500
    },
    {
        name: "March",
        users: 2000,
        posts: 9800,
        incidents: 2290,
        communities: 1000
    },
    {
        name: "April",
        users: 2780,
        posts: 3908,
        incidents: 2000,
        communities: 1200
    },
    {
        name: "May",
        users: 1890,
        posts: 4800,
        incidents: 2181,
        communities: 1600
    },
    {
        name: "June",
        users: 2390,
        posts: 3800,
        incidents: 2500,
        communities: 1800
    },
    {
        name: "July",
        users: 3490,
        posts: 4300,
        incidents: 2100,
        communities: 1700
    },
    {
        name: "August",
        users: 0,
        posts: 0,
        incidents: 0,
        communities: 0
    },
    {
        name: "September",
        users: 0,
        posts: 1500,
        incidents: 0,
        communities: 0
    },
    {
        name: "October",
        users: 1500,
        posts: 0,
        incidents: 0,
        communities: 0
    },
    {
        name: "November",
        users: 0,
        posts: 0,
        incidents: 0,
        communities: 0
    },
    {
        name: "December",
        users: 0,
        posts: 0,
        incidents: 0,
        communities: 0
    }
];
